import BadgeComponent from './Badge.component';
export default BadgeComponent;